module.exports = __webpack_public_path__ + "static/img/add-icon.4ae67a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/add-icon.png
// module id = 195
// module chunks = 41